import { HttpErrorResponse } from '@angular/common/http';
import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Puts an error `AuthInterceptor` has already reported back on the error channel
 * @remarks `AuthInterceptor` handles a network failure, a 401 and a 403 by telling the user and
 * then `return of(error)` — so the `HttpErrorResponse` reaches subscribers as a **value**, on the
 * success channel. A caller that only checks `next` therefore treats a refused call as a
 * successful one; for a decision dialog that means reporting an approval the API declined.
 *
 * This operator is the one place that knows about that contract. Add it to any call whose
 * failure must not pass for success, and handle it in `error:` as normal.
 * @returns Operator that throws the swallowed `HttpErrorResponse` instead of emitting it
 */
export function rethrowHandledHttpError<T>(): OperatorFunction<T, Exclude<T, HttpErrorResponse>> {
  return map((value) => {
    if (value instanceof HttpErrorResponse) {
      throw value;
    }

    return value as Exclude<T, HttpErrorResponse>;
  });
}
